const DEVICE_TOKEN_KEY = "device_token";

function createWebDeviceToken(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `web-${crypto.randomUUID()}`;
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Returns a stable device token for API calls; creates a web fallback if FCM is unavailable. */
export function getOrCreateDeviceToken(): string {
  const existing = localStorage.getItem(DEVICE_TOKEN_KEY);
  if (existing) return existing;

  const token = createWebDeviceToken();
  localStorage.setItem(DEVICE_TOKEN_KEY, token);
  return token;
}

export function setDeviceToken(token: string): void {
  if (token) localStorage.setItem(DEVICE_TOKEN_KEY, token);
}
